import { render, staticRenderFns } from "./TwoStepVerificationDeactivateForm.vue?vue&type=template&id=e8417728"
import script from "./TwoStepVerificationDeactivateForm.vue?vue&type=script&lang=js"
export * from "./TwoStepVerificationDeactivateForm.vue?vue&type=script&lang=js"
import style0 from "./TwoStepVerificationDeactivateForm.vue?vue&type=style&index=0&id=e8417728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports